export default "__VITE_ASSET__Cub2YWEU__"